import angular from "angular";
import template from "./bAdminTable.html";

export function bAdminTableDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bAdminTableController,
    controllerAs: 'bAdminTable',
    bindToController: true,
    scope: {
      name: "=",
      parentDirective: "=",
      data: "=",
      globalActions: "=?",
      rowActions: "=?",
      fields: "=",
      tableSize: "=?",
      searchHidden: "=?",
      titleValue: "=?",
      deleteProcess: "&",
      deleteProcessAvailable: "=?",
      subhead: "=?",
      colspanExtra: "=?",
      hiddenHeads: "=?",
      sort: "=?",
      tooltip: "=?",
      user: "=?",
      pagination: "=?",
      allowArchived: "=?"
    }
  };

  return directive;
}

class bAdminTableController {
  constructor($scope, $translate, Bundle) {
    'ngInject';

    this.Bundle = Bundle;
    this.bundleName = Bundle.getBundleType();
    this.$translate = $translate;
    this.displayedData = this.data ? angular.copy(this.data) : [];
    $scope.$watch("bAdminTable.displayedData", () => {
      this.countAll = this.data && this.data.filter((x) => {return x && (!x.archivedAt || this.allowArchived);}).length;
      this.count = this.displayedData.filter((x) => {return x && (!x.archivedAt || this.allowArchived);}).length;
    });


    $scope.$watch('bAdminTable.displayedData', (n) => {
      if (n[0] && typeof n[0] != 'object') {
        this.isObject = false;
      }
      else {
        this.isObject = true;
      }
    });
  }

  useFunction(functionName, values) {
    this.parentDirective[functionName](values);
  }

  underscoreString(string) {
    return string.split(/(?=[A-Z])/).join("_").toUpperCase();
  }

  showDeleteProcess() {
    return (typeof this.deleteProcess == 'function');
  }

  translateLabel(label){
    if(label === "Hourly"){
      return this.$translate.instant("POSITION.HOURLYNORM");
    }
    if(label === "Worknorm"){
      return this.$translate.instant("POSITION.WORKNORM");
    }
    if(label === "Accepted"){
      return this.$translate.instant("LICENSE_AGREEMENTS.ACCEPTED");
    }
    if(label === "Waiting"){
      return this.$translate.instant("LICENSE_AGREEMENTS.WAITING");
    }
    if(label === "LongTermLeave"){
      return this.$translate.instant("POSITION.LONGTERMLEAVE");
    }
    if(label === "Part time vacation"){
      return this.$translate.instant("COUNTRY.PARTTIMEVACATION");
    }
    return label;
  }

  bundleFeatureFlagsReturn(key){
    if (this.bundleName === 'roedl') return true;
    if (this.bundleName === 'basic') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport",
        "FlexibleWorknormManagement",
        "Flexitime",
        "OfferCalculator",
        "ManagementView",
        "VacationReporting",
        "View360"];
      return !basicKeys.includes(key);
    }
    if (this.bundleName === 'business') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport",
        "OfferCalculator"];
      return !basicKeys.includes(key);
    }
    if (this.bundleName === 'enterprise') {
      const basicKeys = [
        "CASEmanInterfaceConfiguration",
        "CASEmanIncomeImport"];
      return !basicKeys.includes(key);
    }
  }

  bundleFeatureReturn(row) {
    if (this.bundleName === 'roedl') return true;
    if (this.bundleName === 'basic') {
      const basicKeys = [
        "Caseman interface configuration",
        "Caseman income import",
        "Offer calculator",
        "Flexitime",
        "Management view",
        "Offer calculator",
        "Profitability view",
        "360 view"
        ];
      return !basicKeys.includes(row);
    }
    if (this.bundleName === 'business') {
      const basicKeys = [
        "Caseman income import",
        "Caseman interface configuration",
        "Offer calculator"];
      return !basicKeys.includes(row);
    }
    if (this.bundleName === 'enterprise') {
      const basicKeys = [
        "Caseman income import",
        "Caseman interface configuration"];
      return !basicKeys.includes(row);
    }
  }
}
